module.exports = __webpack_public_path__ + "static/media/computer-vision-icon.ec789be6.png";